import { addNamespace } from '@muz/jobboard-vue-client/src/store/helper/namespace';

const namespace = 'CustomJobAd';

const Types = {
    mutations: {
        SET_JOB_AD: 'setJobAd',
    },
};

export const LocalTypes = {
    ...Types,
    namespace,
};

export default {
    ...addNamespace(namespace, Types),
    namespace,
};
